import styled from "@emotion/styled";

import { Row } from "../../components/Layouts";
import DrawerComp from "./private/DrawerComp";

export const DrawerLayout = styled(Row.aside)`
	height: 100%;
`;

export const Wrap = styled(Row)`
	display: flex;
	flex-direction: column;
	height: 100%;
	background: rgba(255, 255, 255, 0.94);
	backdrop-filter: blur(14px);
	width: 100%;
	min-width: 320px;
	overflow: hidden;
`;

export const Header = styled(DrawerComp.Header)`
	width: 100%;
	box-sizing: border-box;
	flex-shrink: 0;
`;

export const Body = styled(DrawerComp.Body)`
	flex-grow: 1;
	width: 100%;
`;
export const Footer = styled(DrawerComp.Footer)`
	width: 100%;
	flex-shrink: 0;
`;

const Drawer = {
	DrawerLayout,
	Wrap,
	Header,
	Body,
	Footer
};

export default Drawer;
